// CardsLoadMore — centered "Load more" button rendered below a DataCards grid,
// the TableFooter counterpart for load-more pagination. Generic: the page owns
// the API calls and pagination state and passes an already-translated label
// (loading here = next page in flight: isFetching && page > 1).

import Button from './Button';

export interface CardsLoadMoreProps {
  /** Renders nothing once every page is loaded. */
  hasMore: boolean;
  /** Next-page fetch in flight — the button spins and disables. */
  loading?: boolean;
  onLoadMore: () => void;
  /** Translated button label, e.g. t('text_load_more'). */
  label: string;
}

const CardsLoadMore = ({ hasMore, loading = false, onLoadMore, label }: CardsLoadMoreProps) => {
  if (!hasMore) return null;

  return (
    <div className='cards-load-more'>
      <Button variant='secondary' loading={loading} onClick={onLoadMore}>
        {label}
      </Button>
    </div>
  );
};

export default CardsLoadMore;
